import { ONE_MINUTE, TEN_MINUTES } from "../constants/time";

const NO_FOCUS_CHANGE_MEDIUM_REFRESH = {
    refetchInterval: TEN_MINUTES,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  } as const,
  MEDIUM_REFETCH = {
    refetchInterval: TEN_MINUTES,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
  } as const,
  MINIMAL_REFETCH = {
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
  } as const,
  SHORT_REFETCH = {
    refetchInterval: ONE_MINUTE,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
  } as const,
  ABSOLUTELY_NO_REFRESH = {
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
  } as const;

export {
  ABSOLUTELY_NO_REFRESH,
  MEDIUM_REFETCH,
  MINIMAL_REFETCH,
  NO_FOCUS_CHANGE_MEDIUM_REFRESH,
  SHORT_REFETCH,
};
